import { render, staticRenderFns } from "./YunshangxueanHome.vue?vue&type=template&id=0519c83f"
import script from "./YunshangxueanHome.vue?vue&type=script&lang=js"
export * from "./YunshangxueanHome.vue?vue&type=script&lang=js"
import style0 from "./YunshangxueanHome.vue?vue&type=style&index=0&id=0519c83f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports